import HTTP from '@/http-common.js'
import EventBus from '@/bus.js'

const UpdatePost = {
  data() {
    return {
      editTimeout: null,
      closeTimeout: null,
    }
  },
  methods: {
    updater(type = 'resource', clone = false) {
      // Check what type of request we want
      let requestURL = `${type}/create`

      if (this.$route.params.id !== undefined && clone === false && type !== 'org') {
        requestURL = `${type}/update/${this.$route.params.id}`
      }

      if (
        // Test if we are editing an existing organisation or the one we belong to
        (this.$route.params.id !== undefined || this.$route.path.includes('settings')) &&
        clone === false &&
        type === 'org'
      ) {
        requestURL = `${type}/${this.item.id}/update`
      } // This freaks me out - same stuff, different route structure (should be type/update/id not type/id/update)

      // On clone replace status with draft and append 'clone' to each language
      if (clone) {
        this.item.status = 'draft'
        this.item.l10n.forEach((translation) => {
          translation.title = `${translation.title} - clone`
        })
      }

      // Create revisions for posts by default. Avoid creating a revision only if the curent post has been reverted to avoid duplicating revisions
      if (this.createRevision) {
        this.$set(this.item, 'revision', true)
      }

      if (this.item.author_id && this.item.authors_id.length) {
        this.item.author_id = this.item.authors_id[0]
      }

      // Create DOC type if uploaded document is DOCX
      if (this.item.type === 'docx') {
        this.item.type = 'doc'
      }

      // Create PPT type if uploaded document is PPTX
      if (this.item.type === 'pptx') {
        this.item.type = 'ppt'
      }

      // Do eet
      HTTP.post(requestURL, this.item)
        .then((response) => {
          this.updating = false

          // Let everyone now that we're live
          this.updated = true

          // Check if there was an update or a new post
          if (
            // Update
            this.$route.params.id !== undefined ||
            this.$route.path.includes('settings')
          ) {
            // Enable edit
            this.editTimeout = setTimeout(() => {
              this.updated = false
            }, 3000)
            // Just update the item
            if (type === 'tag') {
              this.$store.dispatch('updateTag', {
                item: this.item,
                method: 'update',
              })
            } else if (type === 'org') {
              if (this.$store.state.accounts.org.id === this.item.id) {
                this.$store.dispatch('updateUserOrg', response.data)
              }
              this.$store.dispatch('updateOrg', {
                item: this.item,
                method: 'update',
              })
            } else if (clone === false) {
              EventBus.$emit('itemUpdated', JSON.stringify(this.item))
            }

            let data = response.data
            if (type === 'org') {
              delete data.status
              delete data.affiliate_of_id
            }

            // Update data from response
            this.item = data

            if (clone) this.$router.push({ params: { id: this.item.id } })
            // Populate api_keys from websites
            this.item.api_keys = data.websites.map((website) => website.api_key)

            setTimeout(() => {
              this.changed = false
            }, 100)
          } else {
            // New post
            // Update data from response
            this.item = response.data
            this.item.api_keys = response.data.websites.map((website) => website.api_key)
            this.$router.push({
              path: `${this.$route.path}/${response.data.id}`,
              query: { ...this.$route.query },
            })

            // Check if tag, dispatch
            if (type === 'tag') {
              this.$store.dispatch('updateTag', {
                item: this.item,
                method: 'create',
              })
            }

            // Check if current language equals to edited language, update list
            if (
              clone === false &&
              JSON.parse(this.parent.query.search).lang === this.$route.query.lang &&
              JSON.parse(this.parent.query.search).status === this.item.status
            ) {
              // If type equals to tag, update store
              if (type !== 'tag') {
                EventBus.$emit('itemAdded', JSON.stringify(this.item))
              }
            }

            // Check changed status of editor
            setTimeout(() => {
              this.changed = false
            }, 100)

            // Remove success prompt
            this.closeTimeout = setTimeout(() => {
              this.updated = false
            }, 3000)
          }

          // Replace l10n.contents with whatever the server returns, then transform the object to match from e.g. '0' to 'en'
          if (type === 'resource') this.transformTranslationData(response.data.l10n)
        })
        .catch((e) => {
          document.getElementById('editorModal') && document.getElementById('editorModal').scrollTo(0, 0)
          if (e.response) {
            this.errors = e.response ? e.response.data : console.error(e)
          } else {
            this.errors = e
          }
          this.updating = false
          setTimeout(() => {
            this.changed = false
          }, 100)
        })
    },
    update(type, clone) {
      this.updating = true
      this.updated = false
      this.updater(type, clone)
    },
  },
  destroyed() {
    clearTimeout(this.editTimeout)
    clearTimeout(this.closeTimeout)
  },
}

export default UpdatePost
